import { render, staticRenderFns } from "./ScaleHeader.vue?vue&type=template&id=ef8b26c8&lang=pug&"
import script from "./ScaleHeader.vue?vue&type=script&lang=ts&"
export * from "./ScaleHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports